module.exports = __webpack_public_path__ + "img/图片1.a5028c93.png";